/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
    LeadToJSONTyped,
} from './Lead';

/**
 * 
 * @export
 * @interface FindHospitalizedInstances200Response
 */
export interface FindHospitalizedInstances200Response {
    /**
     * 
     */
    data?: Array<Lead>;
}

/**
 * Check if a given object implements the FindHospitalizedInstances200Response interface.
 */
export function instanceOfFindHospitalizedInstances200Response(value: object): value is FindHospitalizedInstances200Response {
    return true;
}

export function FindHospitalizedInstances200ResponseFromJSON(json: any): FindHospitalizedInstances200Response {
    return FindHospitalizedInstances200ResponseFromJSONTyped(json, false);
}

export function FindHospitalizedInstances200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHospitalizedInstances200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadFromJSON)),
    };
}

export function FindHospitalizedInstances200ResponseToJSON(json: any): FindHospitalizedInstances200Response {
    return FindHospitalizedInstances200ResponseToJSONTyped(json, false);
}

export function FindHospitalizedInstances200ResponseToJSONTyped(value?: FindHospitalizedInstances200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadToJSON)),
    };
}

